var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFileImport = function SvgFileImport(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6.339 8",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#275fe0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.169 8h2.672a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-3.56v1.583a.7.7 0 0 1-.7.7H0V7.5a.5.5 0 0 0 .5.5h2.671Zm.1-1.694H1.528a.236.236 0 0 1 0-.471h1.743a.236.236 0 1 1 0 .471Zm1.743-1.2H1.528a.236.236 0 0 1 0-.471h3.485a.236.236 0 0 1 0 .471ZM1.528 3.357h3.485a.236.236 0 0 1 0 .471H1.528a.236.236 0 0 1 0-.471",
    "data-name": "Pfad 347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.223 2.063h1.41a.43.43 0 0 0 .427-.427V.224a.216.216 0 0 0-.217-.216.2.2 0 0 0-.151.064L.07 1.694a.216.216 0 0 0 .153.369",
    "data-name": "Pfad 348"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFileImport);
export default ForwardRef;